import { __assign } from "tslib";
import { headlineColor } from '../../utils/styled-components/color-mixins/color-mixins';
export var BaseFont = 'LeasePlan';
export var fontFamily = BaseFont + ", Arial, Helvetica, sans-serif";
function headlineColorFn(velocityTheme) {
    return headlineColor({ theme: { velocity: velocityTheme } });
}
var MobileAndTabletText = {
    500: {
        fontSize: '1.25rem',
        lineHeight: 1.5,
        fontWeight: 600,
        letterSpacing: 'normal',
        fontFamily: fontFamily,
        loose: {
            lineHeight: 1.8,
        },
        bold: {
            fontWeight: 800,
        },
    },
    400: {
        fontSize: '1.125rem',
        lineHeight: 1.5,
        fontWeight: 600,
        letterSpacing: 'normal',
        fontFamily: fontFamily,
        loose: {
            lineHeight: 1.78,
        },
        bold: {
            fontWeight: 800,
        },
    },
    300: {
        fontSize: '1rem',
        lineHeight: 1.5,
        fontWeight: 600,
        letterSpacing: 'normal',
        fontFamily: fontFamily,
        loose: {
            lineHeight: 1.81,
        },
        bold: {
            fontWeight: 800,
        },
    },
    200: {
        fontSize: '0.875rem',
        lineHeight: 1.5,
        fontWeight: 600,
        letterSpacing: '0.02142em',
        fontFamily: fontFamily,
        loose: {
            lineHeight: 1.79,
        },
        bold: {
            fontWeight: 800,
        },
    },
    100: {
        fontSize: '0.75rem',
        lineHeight: 1.5,
        fontWeight: 600,
        letterSpacing: '0.025em',
        fontFamily: fontFamily,
        loose: {
            lineHeight: 1.83,
        },
        bold: {
            fontWeight: 800,
        },
    },
};
var MobileSizes = {
    headline: {
        600: {
            fontSize: '2.5rem',
            lineHeight: 1.25,
            fontWeight: 800,
            letterSpacing: '-0.0075em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        500: {
            fontSize: '2.0625rem',
            lineHeight: 1.25,
            fontWeight: 800,
            letterSpacing: '-0.00795em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        400: {
            fontSize: '1.75rem',
            lineHeight: 1.25,
            fontWeight: 800,
            letterSpacing: '-0.00785em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        300: {
            fontSize: '1.4375rem',
            lineHeight: 1.26,
            fontWeight: 800,
            letterSpacing: '-0.00695em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        200: {
            fontSize: '1.1875rem',
            lineHeight: 1.26,
            fontWeight: 800,
            letterSpacing: '-0.0095em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        100: {
            fontSize: '1rem',
            lineHeight: 1.38,
            fontWeight: 800,
            letterSpacing: '-0.009375em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
    },
    text: MobileAndTabletText,
};
var TabletSizes = {
    headline: {
        600: {
            fontSize: '3.5rem',
            lineHeight: 1.25,
            fontWeight: 800,
            letterSpacing: '-0.0075em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        500: {
            fontSize: '2.75rem',
            lineHeight: 1.25,
            fontWeight: 800,
            letterSpacing: '-0.00795em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        400: {
            fontSize: '2.125rem',
            lineHeight: 1.26,
            fontWeight: 800,
            letterSpacing: '-0.00795em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        300: {
            fontSize: '1.625rem',
            lineHeight: 1.27,
            fontWeight: 800,
            letterSpacing: '-0.0073em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        200: {
            fontSize: '1.25rem',
            lineHeight: 1.25,
            fontWeight: 800,
            letterSpacing: '-0.0095em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        100: {
            fontSize: '1rem',
            lineHeight: 1.25,
            fontWeight: 800,
            letterSpacing: '-0.0125em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
    },
    text: MobileAndTabletText,
};
var DesktopSizes = {
    headline: {
        600: {
            fontSize: '4.1875rem',
            lineHeight: 1.19,
            fontWeight: 800,
            letterSpacing: '-0.0075em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        500: {
            fontSize: '3.125rem',
            lineHeight: 1.26,
            fontWeight: 800,
            letterSpacing: '-0.008em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        400: {
            fontSize: '2.375rem',
            lineHeight: 1.24,
            fontWeight: 800,
            letterSpacing: '-0.008em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        300: {
            fontSize: '1.75rem',
            lineHeight: 1.25,
            fontWeight: 800,
            letterSpacing: '-0.00715em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        200: {
            fontSize: '1.3125rem',
            lineHeight: 1.29,
            fontWeight: 800,
            letterSpacing: '-0.0095em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
        100: {
            fontSize: '1rem',
            lineHeight: 1.38,
            fontWeight: 800,
            letterSpacing: '-0.0125em',
            fontFamily: fontFamily,
            color: headlineColorFn,
        },
    },
    text: __assign(__assign({}, MobileAndTabletText), { 500: {
            fontSize: '1.5rem',
            lineHeight: 1.5,
            fontWeight: 600,
            letterSpacing: 'normal',
            fontFamily: fontFamily,
            loose: {
                lineHeight: 1.79,
            },
            bold: {
                fontWeight: 800,
            },
        }, 400: {
            fontSize: '1.25rem',
            lineHeight: 1.5,
            fontWeight: 600,
            letterSpacing: 'normal',
            fontFamily: fontFamily,
            loose: {
                lineHeight: 1.8,
            },
            bold: {
                fontWeight: 800,
            },
        } }),
};
export var Typography = {
    mobile: MobileSizes,
    tablet: TabletSizes,
    desktop: DesktopSizes,
};
//# sourceMappingURL=Typography.js.map